<template>
  <div id="app">
    <page-header></page-header>
    <router-view />
    <page-footer></page-footer>
    <modal-download></modal-download>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ModalDownload from "@/components/ModalDownload.vue";

export default {
  components: {
    "page-header": Header,
    "page-footer": Footer,
    "modal-download": ModalDownload
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");

html,
body {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  padding: 0px;
  margin: 0px;
}

#app {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  min-height: 100vh;
  position: relative;
}
</style>
